var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6795 10.0836C15.319 8.47562 13.5807 7.62888 11.7865 8.0332V8.0332C11.4112 8.11755 11.0492 7.88951 11.0089 7.54328V7.54328C10.8195 5.88931 9.33868 4.70799 7.53599 4.95318C5.46886 5.2358 3.91829 7.1035 4.13037 8.95509L4.86433 15.3254C4.91185 15.7368 5.31251 15.9893 5.75841 15.8887L12.6627 14.3305C14.671 13.8778 16.0913 11.928 15.6795 10.0836Z",
    fill: "url(#paint0_linear_17_91)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2599 2.36331C13.9623 1.81653 13.2374 1.6319 12.6206 1.89511V1.89511C12.4875 1.95183 12.3368 1.89707 12.2849 1.77307V1.77307C12.0453 1.19855 11.3804 0.877974 10.7442 1.08527C10.0147 1.32349 9.63786 2.08995 9.9061 2.73311L10.8305 4.94559C10.8903 5.08846 11.0633 5.15134 11.2165 5.08591L13.5897 4.07218C14.28 3.77749 14.6007 2.99059 14.2599 2.36331Z",
    fill: "url(#paint1_linear_17_91)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_17_91",
    x1: 7.79178,
    y1: -0.83807,
    x2: 18.7143,
    y2: 11.3941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B936F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C64C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1005B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_17_91",
    x1: 10.2425,
    y1: -0.987663,
    x2: 15.4316,
    y2: 2.73291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B936F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C64C85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1005B"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.f45dec5451aab99e37522c9ee63a03aa.svg";
export { ForwardRef as ReactComponent };